import Swiper from 'swiper'
import { Navigation } from 'swiper/modules'
import DOMReady from '../utils/DOMReady'

// eslint-disable-next-line no-unused-vars
import css from '../../css/blocks/boats-grid.scss'

class BoatsGrid {
  /**
   * Constructor
   *
   * @param {Element} el HTML element to replace with a vimeo iframe
   */
  constructor(el) {
    this.container = el
    this.galleryElements = this.container.querySelectorAll('.swiper')
    this.init()
  }

  init() {
    if (this.galleryElements.length) {
      this.galleries = Array.from(this.galleryElements).map(
        gallery =>
          new Swiper(gallery, {
            slidesPerView: 1,
            modules: [Navigation],
            navigation: {
              nextEl: gallery.querySelector('.boats-grid__item__button-next'),
              prevEl: gallery.querySelector('.boats-grid__item__button-prev'),
            },
          }),
      )
    }
  }
}

DOMReady(() => {
  const elements = document.querySelectorAll('.boats-grid')
  if (elements !== null) {
    elements.forEach(element => new BoatsGrid(element))
  }
})
